import React from 'react';
import { IconProps } from '../IconProps';

const SvgBack = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 56 56" {...props}>
    <g fill="none" fillRule="evenodd" stroke={primaryColor} strokeWidth={2}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M31.333 36.889L22.444 28l8.89-8.889"
      />
      <circle cx={28} cy={28} r={19} />
    </g>
  </svg>
);

export default SvgBack;
